import axios2 from '../api/axios';
export const clientservices = {
    createdepartment,
    getDepartment,
    createdesignation,
    getDesignations    
}

function createdepartment(objdata){
    return axios2.post(`/createdepartment`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

function getDepartment(id){
    return axios2.get(`/getdepartment?id=${id}`,((response)=>{
         return response;   
    })).catch((error)=>{
         console.log(error); 
    })   
}

function createdesignation(objdata){
    return axios2.post(`/createdesignation`,objdata,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })    
}

function getDesignations(id){
    return axios2.get(`/getdesignations?id=${id}`,((response)=>{
        return response;   
   })).catch((error)=>{
        console.log(error); 
   })   
}

